export default class Bonds {
    constructor(option) {
        this.apiManager = option.apiManager;
    }
    treasury(params) {
        return this.apiManager.getTreasury(params);
    }
    government(params) {
        return this.apiManager.getGovernment(params);
    }
}
